import { Component } from 'react';
import classnames from 'classnames';
import { Autocomplete, Chip, FormControl, TextField } from '@mui/material';
import { WithStyles, withStyles } from '@mui/styles';

// Components - Atoms, Organisms,Containers
import APSelectItem from './APSelectItem';
// Files in the same folder
import APMultiSelectStyles from './styles/APMultiSelect.style';
import { ReactComponent as DeleteIcon } from './assets/icon-close.svg';
import { ReactComponent as AddDropDownIcon } from './assets/icon-add.svg';
import APChipAvatar from './APChipAvatar';
import ErrorIcon from './assets/icon-error.svg';
import ValidIcon from './assets/icon-tick-outline.svg';
// Utils
import { GetDropdownReferenceDataForMultiselect } from '../../../core/utils/GetDropdownReferenceData';

type ReferenceData = {
	label: string;
	value: any;
	icon?: string,
};

interface APSelectProps extends WithStyles<typeof APMultiSelectStyles> {
	children?: any,
	className: string,
	data?: any,
	label?: string,
	onBlur?: any,
	onChange?: any,
	onFocus?: any,
	name?: string,
	value?: any,
	type?: string,
	error?: any,
	selectedValues?: any,
	disabled?: boolean,
}

const REFERENCE_DATA: any = GetDropdownReferenceDataForMultiselect();

class APSelectRef extends Component<APSelectProps, {}> {
	state = {
		icon: undefined,
		inputValue: undefined,
		touched: false
	};

	static getDerivedStateFromProps(props: APSelectProps, state: any) {
		if (state.inputValue !== undefined && state.inputValue !== '') {
			return state;
		}

		return {
			...state,
			inputValue: props.value
		};
	}

	constructor(props: APSelectProps) {
		super(props);

		this.onChange = this.onChange.bind(this);
		this.onInputChange = this.onInputChange.bind(this);
	}

	onChange(event: any, selection: any) {
		const {
			name,
			onChange
		} = this.props;


		this.setState({
			inputValue: undefined,
			touched: true
		}, () => {
			if (onChange) {
				onChange({
					target: {
						name,
						value: selection !== null ? selection : ''
					}
				});
			}
		});
	}

	onInputChange(evt: any, value: string) {
		this.setState({
			inputValue: value,
			touched: true
		});
	}

	render() {
		const {
			name,
			className,
			classes,
			data,
			label,
			onBlur,
			type,
			selectedValues,
			error,
			disabled,
		} = this.props;

		const formControlCls: string = classnames(className, classes.formControl);

		let reference_data: any = data;
		if (!reference_data && type) {
			reference_data = REFERENCE_DATA[type].options;
		}

		let selectedDropDownValues: Array<ReferenceData> = [];
		if (reference_data) {
			selectedValues && selectedValues.length > 0 && selectedValues.forEach((selectedValue) => {
				reference_data.length > 0 && reference_data.forEach((option: ReferenceData) => {
					if (selectedValue === option["value"]) {
						selectedDropDownValues.push(option);
					}
				});
			});
		}

		return (
			<FormControl className={formControlCls} variant="outlined" disabled={disabled}>
				<Autocomplete
					multiple
					id={`AP-multiSelect-${name}`}
					disableCloseOnSelect
					disabled={disabled}
					onBlur={onBlur}
					options={reference_data}
					onChange={this.onChange}
					onInputChange={this.onInputChange}
					getOptionLabel={(option: ReferenceData) => (
						option.label
					)}
					renderInput={(params) => (
						<div className={classes.textFieldWrapper}>
							{this.state.icon && (
								<img className={classes.inputIcon} src={this.state.icon} alt="" />
							)}
							<TextField
								{...params}
								variant="outlined"
								label={label}
								name={name}
								placeholder=""
								error={error}
							/>

							{error && (
								<img className={classes.stateIcon} src={ErrorIcon} alt="Invalid input icon" />
							)}
							{this.state.touched && !error && (
								<img className={classes.stateIcon} src={ValidIcon} alt="Valid input icon" />
							)}
						</div>
					)}
					renderTags={(tagValue, getTagProps) =>
						tagValue.map((option: ReferenceData, index: number) => (
							<Chip
								label={option.label}
								{...getTagProps({ index })}
								avatar={<APChipAvatar {...option} />}
								deleteIcon={<DeleteIcon />} />
						))}
					renderOption={(props, option) => (
						<APSelectItem  {...option}{...props} key={option.value} />
					)}
					popupIcon={<AddDropDownIcon />}
					value={selectedDropDownValues}
				/>
			</FormControl>
		);
	}
}

export default withStyles(APMultiSelectStyles)(APSelectRef);
